module.exports = __webpack_public_path__ + "img/icon-s-broke.4b18b9fa.png";